export * from './IconRemoveFromComparison';
